import * as React from 'react';
import PropTypes from 'prop-types';

export const ThemeContext = React.createContext({
  theme: '',
  setTheme: () => {},
});

function ThemeContextProvider({ children }) {
  const [theme, setTheme] = React.useState('');
  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

ThemeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { ThemeContextProvider };
